import { render } from "./Material.vue?vue&type=template&id=7dd583e5&scoped=true"
import script from "./Material.vue?vue&type=script&lang=js"
export * from "./Material.vue?vue&type=script&lang=js"

import "./Material.vue?vue&type=style&index=0&id=7dd583e5&lang=scss&scoped=true"
import "./Material.vue?vue&type=style&index=1&id=7dd583e5&lang=scss&scoped=true"

import exportComponent from "E:\\RedCigar\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd583e5"]])

export default __exports__